import React, {useEffect} from "react";
import ReactDOM from "react-dom";

export default function ProfileCabinetOnboarding({
                                                     visible,
                                                     onDismiss,
                                                     dismissAriaLabel,
                                                 }) {
    useEffect(() => {
        if (!visible) {
            return undefined;
        }

        document.body.classList.add(
            "profile-cabinet-onboarding-active"
        );

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onDismiss();
            }
        };

        document.addEventListener(
            "keydown",
            handleKeyDown
        );

        return () => {
            document.body.classList.remove(
                "profile-cabinet-onboarding-active"
            );

            document.removeEventListener(
                "keydown",
                handleKeyDown
            );
        };
    }, [
        visible,
        onDismiss,
    ]);

    if (
        !visible ||
        typeof document === "undefined"
    ) {
        return null;
    }

    return ReactDOM.createPortal(
        <button
            type="button"
            className="profile-cabinet-onboarding__backdrop"
            aria-label={dismissAriaLabel}
            onClick={onDismiss}
        />,
        document.body
    );
}
